"use client"

import { Palette } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `PaletteIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const PaletteIcon = component(Icon)({ as: Palette })
